/**
 * US-508. The cosine floors each star band actually uses, and the labels built
 * from them.
 *
 * These were duplicated as hardcoded strings in SourcingPage and
 * SuggestedCandidates, and both still advertised the PRE-RECALIBRATION floors
 * ("5★ Exceptional (≥82%)") months after the API moved 5★ to 0.545. A recruiter
 * setting "Min match: 5★ (≥82%)" on job 132 was told they had selected the top
 * ~1% and received 31 of 67 candidates. The label asserted a number the code
 * does not use — the same defect class as US-507's "AI Score".
 *
 * The percentages are now DERIVED from the floors, so a band cannot be
 * relabelled without changing the number it claims. The floors themselves are
 * mirrored from `scoreToStars`/`cosineFloorForStarsApi` in
 * packages/api/src/routes/api/jobs.ts — packages/web cannot take a workspace
 * dependency (its Dockerfile copies only packages/web and runs a bare
 * npm install), which is the same constraint that forces the calibration-chips
 * mirror. A test pins these against the documented API floors.
 */
export const SOURCING_STAR_FLOORS: Record<number, number> = {
  5: 0.545,
  4: 0.5,
  3: 0.465,
  2: 0.405,
  1: 0,
};

const BAND_NAMES: Record<number, string> = {
  5: 'Exceptional',
  4: 'Strong',
  3: 'Moderate',
  2: 'Weak',
  1: 'All matches',
};

export function starBandLabel(stars: number): string {
  const floor = SOURCING_STAR_FLOORS[stars];
  const name = BAND_NAMES[stars];
  if (stars <= 1 || floor === undefined) return `${stars}★ ${name ?? ''}`.trim();
  return `${stars}★ ${name} (≥${Math.round(floor * 100)}%)`;
}

export const STAR_LABELS: Record<number, string> = Object.fromEntries(
  [5, 4, 3, 2, 1].map((s) => [s, starBandLabel(s)]),
);
